<ng-template #profileSidebar>
  <div class="sidebar">
    <div [ngClass]="{ 'active': activePage === 'user-profile' }">
      <a [routerLink]="userProfileLink">{{ "PROFILE.MY_TICKETS" | translate }}</a>
    </div>

    <div *ngIf="appConfig.appHasMembership" [ngClass]="{ 'active': activePage === 'membership-profile' }">
      <a routerLink="/membership-profile">{{  "PROFILE.MY_MEMBERSHIP" | translate }}</a>
    </div>

    <div [ngClass]="{ 'active': activePage === 'group-tickets-profile' }">
      <a routerLink="/group-tickets-profile">{{ "PROFILE.GROUP_TICKETS" | translate }}</a>
    </div>

    <div [ngClass]="{ 'active': activePage === 'transfer-tickets', 'disabled': (!hasConnectedGroupTicket || !hasGamesForDelegation) }">
      <a *ngIf="hasGamesForDelegation || transferTicketLoading" routerLink="/transfer-tickets">{{ "COMMON.RETURN_TICKET" | translate }}</a>
      <a *ngIf="(!hasConnectedGroupTicket || !hasGamesForDelegation) && !transferTicketLoading" class="default-cursor">{{ "COMMON.RETURN_TICKET" | translate }}</a>

      <span *ngIf="!hasConnectedGroupTicket && !transferTicketLoading" class="tooltip-ticket-label">
        {{ "NAVIGATION.TOOLTIP_NO_CONNECTED_GROUP_TICKET" | translate }} <br/>
        {{ "NAVIGATION.TOOLTIP_NO_CONNECTED_GROUP_TICKET_2" | translate }}
      </span>
      <span *ngIf="!hasGamesForDelegation && hasConnectedGroupTicket && !transferTicketLoading" class="tooltip-ticket-label">{{ "NAVIGATION.TOOLTIP" | translate }}</span>
    </div>

    <div [ngClass]="{ 'active': activePage === 'update-profile' }">
      <a [routerLink]="updateProfileLink">{{ "PROFILE.EDIT_PROFILE" | translate }}</a>
    </div>

    <div  [ngClass]="{ 'active': activePage === 'my-cards' }">
      <a routerLink="/my-cards">{{ "PROFILE.MY_CARDS" | translate }}</a>
    </div>
  </div>
</ng-template>

<div class="sidebar-desktop">
  <ng-container *ngTemplateOutlet="profileSidebar"></ng-container>
</div>

<app-accordion class="profile-accordion">
  <app-accordion-item [title]="activePageFormatted">
    <ng-container *ngTemplateOutlet="profileSidebar"></ng-container>
  </app-accordion-item>
</app-accordion>